import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App.tsx'
import {
  applyTheme,
  defaultThemeId,
  isThemeId,
} from '@/lib/themes.ts'
import '@/styles/index.css'

/** 渲染前同步主题，减少非默认主题的首屏色差 */
try {
  const raw = localStorage.getItem('promot-theme')
  const stored = raw ? (JSON.parse(raw) as { state?: { theme?: string } }) : null
  const theme = stored?.state?.theme
  applyTheme(theme && isThemeId(theme) ? theme : defaultThemeId)
} catch {
  applyTheme(defaultThemeId)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
